export default __webpack_public_path__ + "static/media/meafoster.909bc63c.jpg";